export default  {
  viewBox: "0 0 24 24",
  paths: [
    "M24 12.7764L2.973 12.7761L11.9958 21.8006L10.8981 22.8983L0 12.0002L10.8981 1.10205L11.9958 2.19976L2.974 11.2231L24 11.224V12.7764Z"
  ]
};